var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");

if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var DragDropStateMachine = require("./dragDropStateMachine.js");

var Editor3d = require("./../editor3d/editor3dController.js");

if(ui_extensions) {
    var UploadController = ui_extensions.UploadController;
}


var DragDropController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);

    lib_core.GuiEvents.addEvents({
        DD_UPLOAD:                {id: 'dd_upload_01', name: "DD_UPLOAD" },
        DD_FILE_LOADED:           {id: 'dd_upload_02', name: "DD_FILE_LOADED" }
    });
};
lib_core.inherit(DragDropController, lib_core.Controller);
DragDropController.inject = {
    editor3d : Editor3d,
    upload   : UploadController
};

module.exports = DragDropController;


DragDropController.prototype.createStateMachine = function () {
    return new DragDropStateMachine(this.root, this.getModel(), this.upload && this.upload.getStatemachine(), this.editor3d.getView());
};


